import { DB006Api } from "./ServiceImpl";

const DM006Service = (api: DB006Api) => {
  return {};
};

export default DM006Service;
